import React, { useState, ReactNode, Fragment } from "react";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/icons/arrow_up.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as SaveIcon } from "../../assets/icons/save.svg";
import { ReactComponent as CancelIcon } from "../../assets/icons/close.svg";

type AccordionProps = {
  title: any;
  subtitle?: any;
  className?: string;
  children?: ReactNode;
  expanded?: boolean;
  onEdit?: any;
  onSave?: any;
};

const Accordion = (props: AccordionProps) => {
  const [expanded, setExpanded] = useState(props.expanded || false);
  const [editMode, setEditMode] = useState(false);

  const handleEditMode = () => {
    props.onEdit && props.onEdit();
    setEditMode((currentValue) => !currentValue);
    console.log(editMode);
  };

  const handleSaveMode = () => {
    props.onSave && props.onSave();
    setEditMode((currentValue) => !currentValue);
  };

  const handleCancelMode = () => {
    props.onEdit && props.onEdit();
    setEditMode((currentValue) => !currentValue);
  };

  return (
    <div className={`accordion ${props.className}`}>
      <div className="accordion-item">
        <div className="accordion-title" onClick={() => setExpanded(!expanded)}>
          <div>{props.title}</div>
          <div className="accordion-button-container">
            {expanded ? (
              <button className="accordion-button">
                <ArrowUpIcon className="accordion-svg" />
              </button>
            ) : (
              <button className="accordion-button">
                <ArrowDownIcon className="accordion-svg" />
              </button>
            )}
          </div>
        </div>
        {props.subtitle && (
          <div className="accordion-subtitle">{props.subtitle}</div>
        )}
        {expanded && (
          <Fragment>
            {props.onEdit &&
              (editMode ? (
                <div className="save-icon-container">
                  {
                    <SaveIcon
                      onClick={handleSaveMode}
                      className="save-icon icon"
                    />
                  }
                  {
                    <CancelIcon
                      onClick={handleCancelMode}
                      className="cancel-icon icon"
                    />
                  }
                </div>
              ) : (
                <div className="edit-icon-container">
                  {
                    <EditIcon
                      onClick={handleEditMode}
                      className="edit-icon icon"
                    />
                  }
                </div>
              ))}
            <div className="accordion-content">{props.children}</div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Accordion;
